import phone from '../images/fit/fit_sales/group-15@2x.png'
import leave from '../images/fit/fit_sales/leave@2x.png'
import attendance from '../images/fit/fit_sales/attendance@2x.png'
import contactmngmt from '../images/fit/fit_sales/contact-mngmt@2x.png'
import missionmngmtvig from '../images/fit/fit_sales/mission-mngmt-vig@2x.png'
import claim from '../images/fit/fit_sales/claim@2x.png'
import dashboard from '../images/fit/fit_sales/dashboard@2x.png'
import leaderboard from '../images/fit/fit_sales/leaderboard@2x.png'
import integrations from '../images/fit/fit_sales/integrations@2x.png'
import leadmanagement from '../images/fit/fit_sales/lead-management@2x.png'
import locationmanagementfinal from '../images/fit/fit_sales/location-managementfinal@2x.png'
import incentives from '../images/fit/fit_sales/incentives@2x.png'


export const fitSalesData = {
    landing_image: phone,
    about: 'Hubler brings you a suite of easy-to-use and customizable apps.',
    aboutPara: 'No more exhausted sales execs. No more lost leads. No more broken computer screens or screaming employees.\n' +
    'From leads & customer engagement, to on-field workforce management, to actionable insights and reports.' +
    ' Imagine everything aligned, on one platform.\n' +
    'Here’s what Hubler does for you…',
    infoList: [{
        id: '1',
        name: 'All customers’ insights, at your fingertips',
        image:contactmngmt,
        sub_title: 'Customers & contacts management',
        url: '',
        description: 'From important information of your customers, to leads pipelines & status of closures and progress tracking…all organized and made sense of…smoothen your sales process with just a few clicks.'
    },{
        id: '2',
        name: 'Manage your Leads, your way',
        image:leadmanagement,
        sub_title: 'Leads & opportunities',
        url: '',
        description: 'Alright, you’ve tried 100 other lead management apps. But this one has a twist. You can customize it to align to your organisation’s processes. Capture critical customer data - view pipelines according to your products, services, and more. All in real-time.'
    }, {
        id: '3',
        name: 'Make leaves stress-free',
        image:leave,
        sub_title: 'Leaves Management',
        url: '',
        description: 'Alarmed at field guys taking sudden leaves? Hubler makes it easy for your to plan when your employees take an off-day. Assign leave limits to plan and manage better - never be caught without your army.'
    },{
        id: '4',
        name: 'Let everyone know the big picture',
        image:missionmngmtvig,
        sub_title: 'Missions and goals',
        url: '',
        description: 'Arm your teams with real-time goal tracking. Give your workforce a clear visibility of goals they need to work for. If your employees know exactly what to do next, work is no longer work.'
    },{
        id: '5',
        name: 'Know where the action is, in real-time',
        image:locationmanagementfinal,
        sub_title: 'Locations and remote check-ins',
        url: '',
        description: 'Increase business intelligence with live location updates of your field sales execs. You can review client check-ins, and record the locations of positive engagement. Make remote-working possible anytime with just a click.'
    },{
        id: '6',
        name: 'Mark attendance from anywhere',
        image:attendance,
        sub_title: 'Attendance and people',
        url: '',
        description: 'Remove commute-time problems for your employees. Make it easy to work from anywhere - with accurate tracking of working hours. \n' +
        'Also, manage shifts and region-wise profiles of employees. \n' +
        'Lose no data as it is synced across all Hubler apps.'
    },/*{
        id: '7',
        name: 'Name of the case study',
        highlight:true,
        image:leave,
        sub_title: 'Case Study 01',
        url: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation'
    },*/{
        id: '8',
        name: 'Claims treated right, without the clutter',
        image:claim,
        sub_title: 'Claims and reimbursements',
        url: '',
        description: 'Is your team wasting critical time just filing claims? Now they can mark claims in real-time, attach ' +
        'bills on the go. You can track multiple claims’ status easily, and approve them faster. Say goodbye to the long ' +
        'list of excel sheets you’re approving.'
    },{
        id: '9',
        name: 'Automate Analysis, make it actionable',
        image:dashboard,
        sub_title: 'Dashboards and insights',
        url: '',
        description: 'Enhance sales results with insights you want - just feed data and get automated analysis on what you want, ' +
        'the dashboards will do the rest. Also, try more widgets for a complete business view of actionable business data.'
    },{
        id: '10',
            name: 'Step-up work cultures',
            image:leaderboard,
            sub_title: 'Leaderboards and recognitions',
            url: '',
            description: 'Make work awesome with real-time rankings of your company’s performers. Inspire workforce with regularly updating success stories in Hubler’s Leaderboard app.'
    },/*{
            id: '11',
            image:leave,
            highlight:true,
            name: 'Name of the case study',
            sub_title: 'Case Study 02',
            url: '',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation'
        },*/
        {
            id: '12',
            image:incentives,
            name: 'Make examples out of top performers',
            sub_title: 'Incentives and updates',
            url: '',
            description: 'Let your team know that you got their back with regular and fair appreciation. Manage a clear record of their incentives and boost your team’s morale.'
        },
        {
            id: '13',
            name: 'Bring out the best from all your systems',
            image:integrations,
            sub_title: 'Integrations with other apps',
            url: '',
            description: 'Make safer accounts and payments with tighter integration of business and service related data. ' +
            'Get faster integration of financial data from apps. See smart automation adapt to your systems for progress.'
        }

    ]
}


// WEBPACK FOOTER //
// ./src/data/fit-sales.js